// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidatePostalCode } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {
    AddressFieldDisplayCollectionModel,
    BaseAddressModel,
    CustomerValidationDto,
} from "@insite/client-framework/Types/ApiModels";
import { isValidPostalCode } from "@store/Framework/Common/Utilities/validations";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

export type AddressErrors = SafeDictionary<React.ReactNode>;

type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<AddressErrors>,
    {
        addressErrors: AddressErrors;
    }
>;

const isEmpty = (value: string) => value.trim().length <= 0;

const ValidatePostalCodeFormat: HandlerType = props => {
    const { postalCode } = props.parameter.address;

    if (!isEmpty(postalCode) && !isValidPostalCode(postalCode)) {
        props.addressErrors.postalCode = siteMessage("AddressInfo_Postal_Code_Validation");
    }
};

addToChainAfter(chain, ValidatePostalCode, ValidatePostalCodeFormat);
